<template>
  <template v-if="isInit">
    <table class="tb-row">
      <colgroup>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>환급은행</th>
        <td>
          <cd-selbx :cds="bnks"
                    :cd="rtunBnkCd"
                    :is-select="true"
                    :width="'100%'"
                    @select="selbxRtunBnkCd_select"/>
        </td>
        <th>예금주</th>
        <td class="last">
          <input type="text"
                 class="txt"
                 maxlength="20"
                 style="width:150px;"
                 v-model="rtunDpstr"/>
        </td>
      </tr>
      <tr>
        <th>환급계좌번호</th>
        <td colspan="3" class="last">
          <number-ip :data="rtunCcno"
                     :maxlength="20"
                     :width="'100%'"
                     @input="ipRtunCcno_input"/>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="layer-btn">
      <btn :txt="'취소'"
           :color="'white'"
           @click="btnCancl_click"/>
      <btn :txt="'변경'"
           :color="'purple'"
           @click="btnChng_click"/>
    </div>
  </template>
</template>

<script setup>
import {defineEmits, defineProps, onMounted, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";

const {$cd, $axios, $cmmn, $alert} = getUtils();
const {$loading, $mber} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true
  }
})

const emits = defineEmits(['close', 'chng-compt']);
const btnCancl_click = () => {
  close();
}

const close = () => {
  emits('close');
}

const bnks = ref([]);
const ccnSn = ref(null);
const rtunBnkCd = ref('');
const rtunDpstr = ref('');
const rtunCcno = ref('');
const selbxRtunBnkCd_select = (data) => {
  rtunBnkCd.value = data;
}

const ipRtunCcno_input = (data) => {
  rtunCcno.value = data;
}

const getRrcnInfo = async () => {
  const {data} = await $axios.get('/api/fclty/rrcn-info/by-fclty-sn?', {params: {fcltySn: props.fcltySn}});
  if (data) {
    ccnSn.value = data.ccnSn;
    rtunBnkCd.value = data.ccnBkcd;
    rtunDpstr.value = data.ccnDpstrNm;
    rtunCcno.value = data.ccnoDecr;
  }
};

const valid = () => {
  let isValid = true;
  let msg = '';

  if (isValid && !rtunBnkCd.value) {
    isValid = false;
    msg = '환급은행을 선택해주세요.';
  }

  if (isValid && !rtunDpstr.value) {
    isValid = false;
    msg = '예금주를 입력해주세요.';
  }

  if (isValid && !rtunCcno.value) {
    isValid = false;
    msg = '환급계좌번호를 입력해주세요.';
  }

  return {isValid, msg};
}

const btnChng_click = async () => {
  try {
    $loading.on();

    const {isValid, msg} = valid();
    if (!isValid) {
      await $alert(msg);
      return false;
    }

    const modifyParams = {
      mberSn: $mber.mberSn,
      fcltySn: props.fcltySn,
      ccnSn: ccnSn.value,
      rrcnBkcd: rtunBnkCd.value,
      rrcnCcnoDecr: rtunCcno.value,
      rrcnDpstr: rtunDpstr.value
    }

    await modifyFcltyRrcn(modifyParams);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const modifyFcltyRrcn = async (modifyParams) => {
  await $axios.post('/api/fclty/rrcn-info', modifyParams);
  await $alert('환급계좌정보 변경이 완료되었습니다.');

  emits('chng-compt');
  close();
}

const isInit = ref(false);
const init = async () => {
  const [cds]
          = await Promise.all([$cd.getCmmnCds('SYS0086'), getRrcnInfo()]);

  bnks.value = cds;

  isInit.value = true;
}

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
